// extracted by mini-css-extract-plugin
export default {"buttonGroups":"AluList_buttonGroups__zqUMx","li":"AluList_li__FIFiq","link":"AluList_link__IRAq4","selected":"AluList_selected__wVtxG"};